import React, { useMemo } from 'react';
import Link from 'next/link';
import { useSelector, useDispatch } from 'react-redux';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { AiFillSignal } from 'react-icons/ai';
import { IoSearch } from 'react-icons/io5';
import dayjs from 'dayjs';
import { mapModifiers } from '@/utils/funtion';
import { ContextualIndicator } from '@/interfaces/home';
import Input from '@/components/atoms/Input';
import Empty from '@/components/atoms/empty';
import Icon from '@/components/atoms/icon';
import { setDetailUrl } from '@/stores/modules/detailUrl';
import { AreaVariant } from '../../mapsPackage';

interface IndicatorListProps {
  searchData: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filteredIndicators: ContextualIndicator[];
  activeId: string;
  setActiveId: (id: string) => void;
  setType: (type: string) => void;
  handleGetChardData: (
    id: string,
    type: string,
    isStructure: number,
    time: string,
    isObjectOneTime: number,
  ) => void;
  slug: string;
  area?: AreaVariant;
}

const IndicatorList: React.FC<IndicatorListProps> = ({
  searchData,
  handleInputChange,
  filteredIndicators,
  activeId,
  setActiveId,
  setType,
  handleGetChardData,
  slug,
  area,
}) => {
  const userData = useSelector((state: any) => state.userData);
  const dispatch = useDispatch();

  const sortedIndicators = useMemo(() => {
    return [...filteredIndicators].sort((a: any, b: any) => {
      const aUpdatedAt =
        a.indicator?.updatedAt ||
        a.industryIndicator?.updatedAt ||
        a.localIndicator?.updatedAt;
      const bUpdatedAt =
        b.indicator?.updatedAt ||
        b.industryIndicator?.updatedAt ||
        b.localIndicator?.updatedAt;

      const aIsToday = dayjs(aUpdatedAt).isAfter(dayjs().subtract(3, 'day'));
      const bIsToday = dayjs(bUpdatedAt).isAfter(dayjs().subtract(3, 'day'));

      if (aIsToday && !bIsToday) return -1;
      if (!aIsToday && bIsToday) return 1;
      return dayjs(bUpdatedAt).valueOf() - dayjs(aUpdatedAt).valueOf();
    });
  }, [filteredIndicators]);

  const memoIndicatorList = useMemo(() => {
    return (
      <React.Fragment>
        <div className="indicator-session-list_search">
          <Input
            type="search"
            placeholder="Tìm kiếm chỉ số"
            value={searchData}
            onChange={handleInputChange}
            enterButton={<IoSearch />}
          />
        </div>
        {!sortedIndicators?.length ? (
          <div className="indicator-session-list_empty">
            <Empty />
          </div>
        ) : (
          <div className="indicator-session-list-content">
            {sortedIndicators?.map((item: any) => {
              const {
                slug,
                id,
                type,
                isStructure,
                isObjectOneTime,
                updatedAt,
              } =
                item.indicator ||
                item.industryIndicator ||
                item.localIndicator ||
                {};
              const isToday = dayjs(updatedAt).isAfter(
                dayjs().subtract(3, 'day'),
              );

              return (
                <div
                  key={id}
                  className={mapModifiers(
                    'indicator-session-item',
                    id === activeId ? 'active' : '',
                  )}
                >
                  <div className="indicator-session-item_icon">
                    <Icon
                      component={
                        activeId === id ? (
                          <FaArrowAltCircleRight />
                        ) : (
                          <AiFillSignal />
                        )
                      }
                    />
                  </div>
                  <div
                    key={id}
                    className={mapModifiers(
                      'indicator-session-item_content',
                      id === activeId ? 'active' : '',
                    )}
                    onClick={() => {
                      setActiveId(id);
                      setType(type);
                      handleGetChardData(
                        id,
                        type,
                        isStructure ? 1 : 0,
                        '',
                        isObjectOneTime ? 1 : 0,
                      );
                    }}
                  >
                    {item.indicator?.name ||
                      item.industryIndicator?.name ||
                      item.localIndicator?.name}
                    <a
                      href={`/thong-tin-chi-tiet/${slug}/${id}?type=${type}&area=${area}&structure=${isStructure}&isObjectOneTime=${isObjectOneTime}`}
                    >
                      [Chi tiết]
                    </a>
                    {isToday && (
                      <div className="indicator-session-item_content_new">
                        <Icon iconName="newest" size="28x28" />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  }, [
    sortedIndicators,
    activeId,
    searchData,
    handleInputChange,
    setActiveId,
    setType,
    handleGetChardData,
    slug,
  ]);

  return memoIndicatorList;
};

export default IndicatorList;
